/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: metadata_registry.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateMetadataRegistryEntryRequest,
  CreateMetadataRegistryEntryResponse,
  DeleteMetadataRegistryEntryRequest,
  DeleteMetadataRegistryEntryResponse,
  GetMetadataRegistryEntryRequest,
  GetMetadataRegistryEntryResponse,
  ListMetadataRegistryEntriesRequest,
  ListMetadataRegistryEntriesResponse,
  UpdateMetadataRegistryEntryRequest,
  UpdateMetadataRegistryEntryResponse,
} from '../types/metadata_registry';

export const createMetadataRegistryService = (transport: Transport) => ({
  async createMetadataRegistryEntry(
    request: CreateMetadataRegistryEntryRequest,
    options: RequestOptions = {},
  ): Promise<CreateMetadataRegistryEntryResponse> {
    const url = getApiPath(API_METHODS.MetadataRegistryService.CreateMetadataRegistryEntry);
    return transport.post<CreateMetadataRegistryEntryResponse>(url, request, options);
  },

  async getMetadataRegistryEntry(
    request: GetMetadataRegistryEntryRequest,
    options: RequestOptions = {},
  ): Promise<GetMetadataRegistryEntryResponse> {
    const { entry_id, ...params } = request;
    const url = getApiPath(API_METHODS.MetadataRegistryService.GetMetadataRegistryEntry, {
      entry_id,
    });
    return transport.get<GetMetadataRegistryEntryResponse>(url, { params, ...options });
  },

  async listMetadataRegistryEntries(
    request: ListMetadataRegistryEntriesRequest,
    options: RequestOptions = {},
  ): Promise<ListMetadataRegistryEntriesResponse> {
    const url = getApiPath(API_METHODS.MetadataRegistryService.ListMetadataRegistryEntries);
    return transport.get<ListMetadataRegistryEntriesResponse>(url, { params: request, ...options });
  },

  async updateMetadataRegistryEntry(
    request: UpdateMetadataRegistryEntryRequest,
    options: RequestOptions = {},
  ): Promise<UpdateMetadataRegistryEntryResponse> {
    const { entry_id, ...body } = request;
    const url = getApiPath(API_METHODS.MetadataRegistryService.UpdateMetadataRegistryEntry, {
      entry_id,
    });
    return transport.post<UpdateMetadataRegistryEntryResponse>(url, body, options);
  },

  async deleteMetadataRegistryEntry(
    request: DeleteMetadataRegistryEntryRequest,
    options: RequestOptions = {},
  ): Promise<DeleteMetadataRegistryEntryResponse> {
    const { entry_id, ...body } = request;
    const url = getApiPath(API_METHODS.MetadataRegistryService.DeleteMetadataRegistryEntry, {
      entry_id,
    });
    return transport.delete<DeleteMetadataRegistryEntryResponse>(url, { data: body, ...options });
  },
});

export type MetadataRegistryService = ReturnType<typeof createMetadataRegistryService>;
